import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import type { CellProps } from 'react-table';

import type { Tournament } from '@swf/poker';
import { useFormattedBuyIn } from '@swf/poker';

import TableCellBase from './TableCellBase';
import { TXTMOB_Buy_inX } from './TableCellBuyIn.messages.json';

type Props = CellProps<Tournament> & { showLabel?: boolean };

const TableCellBuyIn: React.FC<Props> = memo((props) => {
  const { formatMessage } = useIntl();
  const { row, showLabel } = props;
  let displayValue = showLabel ? `${formatMessage(TXTMOB_Buy_inX)} ` : '';
  displayValue += useFormattedBuyIn(row.original);

  return <TableCellBase {...props} displayValue={displayValue} />;
});

export default TableCellBuyIn;
